import React from "react";
import PT from "prop-types";
import { ORDERS_NS as ns } from "@/i18n/ns";
import { analyticsAction } from "@/utils/analytics";
import { Menu, MenuItem, MenuButton } from "_c/Menu";
import DotsIcon from "_c/icon/Dots";

const btnNs = `${ns}:order.buttons`;
const tipNs = `${ns}:tooltips`;
const TaskInterface = ({
  hasReview,
  buttonsAppear: appear,
  isTaskConsumer,
  finishMut,
  removeMut,
  acceptMut,
  requestPhotoMut,
  payLinkMut,
  copyMut,
  requestReviewMut,
  removeDisputeMut,
  t,
  remind,
  // sendMessage,
  openEditor,
  toggleAction,
  openWarehouseTxnEditor,
  requestPayout,
  copyIdToClipboard,
}) => {
  const i18nRole = isTaskConsumer ? "client" : "pro";
  return (
    <div>
      <Menu
        portal
        menuButton={
          <MenuButton
            css={`
              padding: 5px;
              padding-bottom: 0;
            `}
          >
            <DotsIcon width="24" />
          </MenuButton>
        }
      >
        {appear.requestPayout && (
          <MenuItem onClick={requestPayout}>
            {t(`${btnNs}.request_payout`)}
          </MenuItem>
        )}
        {appear.pay && (
          <MenuItem
            disabled={payLinkMut.isLoading}
            onClick={payLinkMut.mutate}
            title={t(`${tipNs}.pay_button`)}
          >
            {t(`${btnNs}.pay`)}
          </MenuItem>
        )}
        {appear.accept && (
          <MenuItem
            disabled={acceptMut.isLoading}
            onClick={() => {
              analyticsAction({
                category: "records",
                action: "rec_confirm",
              });
              acceptMut.mutate();
            }}
            title={t(`${tipNs}.confirm_button`)}
          >
            {t(`${btnNs}.accept`)}
          </MenuItem>
        )}
        {appear.remind && (
          <MenuItem onClick={remind}>{t(`${btnNs}.remind`)}</MenuItem>
        )}
        {appear.finish && (
          <MenuItem
            disabled={finishMut.isLoading}
            onClick={finishMut.mutate}
            title={t(`${tipNs}.finish_button.${i18nRole}`)}
          >
            {t(`${btnNs}.finish`)}
          </MenuItem>
        )}
        {/*appear.message && (
          <MessagePopover t={t} onSubmit={sendMessage}>
            <S.InterfaceButton
              onClick={() => {
                analyticsAction({
                  category: "records",
                  action: "rec_message",
                });
              }}
              title={t(`${tipNs}.message_button.${i18nRole}`)}
            >
              {t(`${btnNs}.message`)}
            </S.InterfaceButton>
          </MessagePopover>
        )*/}
        {appear.change && (
          <MenuItem onClick={openEditor} title={t(`${tipNs}.change_button`)}>
            {t(`${btnNs}.change`)}
          </MenuItem>
        )}
        <MenuItem
          title={t(`${tipNs}.note_button`)}
          onClick={() => {
            analyticsAction({
              category: "records",
              action: "rec_note",
            });
            toggleAction("note");
          }}
        >
          {t(`${btnNs}.note`)}
        </MenuItem>
        {appear.photoUpload && (
          <MenuItem
            onClick={() => {
              analyticsAction({
                category: "records",
                action: "rec_photo",
              });
              toggleAction("upload");
            }}
            title={t(`${tipNs}.load_photo_button.${i18nRole}`)}
          >
            {t(`${btnNs}.load_photo`)}
          </MenuItem>
        )}
        {appear.review && (
          <MenuItem
            title={t(`${tipNs}.review_button`)}
            onClick={() => toggleAction("review")}
          >
            {t(`${btnNs}.${hasReview ? "review_update" : "review"}`)}
          </MenuItem>
        )}
        {appear.dispute && (
          <MenuItem
            title={t(`${tipNs}.dispute_button`)}
            onClick={() => toggleAction("dispute")}
          >
            {t(`${btnNs}.dispute`)}
          </MenuItem>
        )}
        {appear.disputeUpdate && (
          <MenuItem onClick={() => toggleAction("dispute")}>
            {t(`${btnNs}.dispute_update`)}
          </MenuItem>
        )}
        {appear.disputeRemove && (
          <MenuItem
            disabled={removeDisputeMut.isLoading}
            onClick={removeDisputeMut.mutate}
          >
            {t(`${btnNs}.dispute_remove`)}
          </MenuItem>
        )}
        {appear.reviewRequest && (
          <MenuItem
            disabled={requestReviewMut.isLoading}
            onClick={requestReviewMut.mutate}
          >
            {t(`${btnNs}.request_review`)}
          </MenuItem>
        )}
        {appear.photoRequest && (
          <MenuItem
            disabled={requestPhotoMut.isLoading}
            title={t(`${tipNs}.ask_photo_button.${i18nRole}`)}
            onClick={requestPhotoMut.mutate}
          >
            {t(`${btnNs}.ask_photo`)}
          </MenuItem>
        )}
        {appear.copy && (
          <MenuItem
            disabled={copyMut.isLoading}
            onClick={copyMut.mutate}
            title={t(`${tipNs}.cancel_button.${i18nRole}`)}
          >
            {t("common:todos.cp")}
          </MenuItem>
        )}
        {appear.createWarehouseTxn && (
          <MenuItem
            onClick={() => {
              openWarehouseTxnEditor({
                defaultDirection: "out",
              });
            }}
          >
            {t(`${btnNs}.warehouse_withdraw`)}
          </MenuItem>
        )}
        {appear.cancel && (
          <MenuItem
            onClick={() => toggleAction("cancel")}
            title={t(`${tipNs}.cancel_button.${i18nRole}`)}
            style={{ color: "var(--color-danger)" }}
          >
            {t(`${btnNs}.cancel`)}
          </MenuItem>
        )}
        {appear.remove && (
          <MenuItem
            onClick={() => {
              analyticsAction({
                category: "records",
                action: "rec_delete",
              });
              removeMut.mutate();
            }}
            style={{ color: "var(--color-danger)" }}
            disabled={removeMut.isLoading}
            title={t(`${tipNs}.remove_button`)}
          >
            {t(`${btnNs}.remove`)}
          </MenuItem>
        )}
        <MenuItem onClick={copyIdToClipboard}>{t(`${btnNs}.id`)}</MenuItem>
      </Menu>
    </div>
  );
};

TaskInterface.propTypes = {
  taskId: PT.string.isRequired,
  hasReview: PT.bool.isRequired,
  note: PT.string,
  buttonsAppear: PT.object.isRequired,
  removeMut: PT.object.isRequired,
  finishMut: PT.object.isRequired,
  acceptMut: PT.object.isRequired,
  requestPhotoMut: PT.object.isRequired,
  requestReviewMut: PT.object.isRequired,
  payLinkMut: PT.object.isRequired,

  remind: PT.func.isRequired,
  openEditor: PT.func.isRequired,
  t: PT.func.isRequired,
  toggleAction: PT.func.isRequired,
  sendMessage: PT.func.isRequired,
};
export default TaskInterface;
